<template>
  <div class="app-base">
    <p class="title text-center">
      <span>Organizations</span>
    </p>

    <div class="row">
      <div
        v-for="org in organization.organizationsMini"
        :key="org.id"
        class="col-sm-4"
      >
        <OrgCard :organization="org" />
      </div>
    </div>

    <p class="view-more text-center">
      <span>
        <button @click="routeToOrganizations" class="btn btn-danger app-btn">
          View More
        </button>
      </span>
    </p>
  </div>
</template>

<style></style>

<script>
import OrgCard from "../Cards/OrgCard";
import { mapState } from "vuex";
export default {
  name: "AppLanding",
  components: { OrgCard },
  computed: {
    ...mapState(["organization"])
  },
  methods: {
    routeToOrganizations() {
      this.$router.push({ name: "organizations" });
    }
  }
};
</script>
